import React from "react";
import Input, {
  type DefaultInputComponentProps,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import ar from "react-phone-number-input/locale/ar.json";
import tr from "react-phone-number-input/locale/tr.json";
import fr from "react-phone-number-input/locale/fr.json";
import { useIntl } from "@/i18n/i18n-client";
import { customPhoneValidation } from "@/shared/utils/custom-phone-validation";

const languageMapper = {
  // default is "en" so no need to be handled
  "ar-EG": ar,
  "fr-FR": fr,
  "tr-TR": tr,
};

export interface ReactPhoneNumberInputProps extends DefaultInputComponentProps {
  onChange: (value: string, isValid: boolean) => void;
}

const ReactPhoneNumberInput: React.FC<ReactPhoneNumberInputProps> = ({
  onChange,
  ...restProps
}) => {
  const { locale } = useIntl();
  const languageTemplate = languageMapper[locale];
  return (
    <Input
      labels={languageTemplate}
      onChange={(value) => {
        const parsedValue = parsePhoneNumber(value || "");
        const isValid = value
          ? isValidPhoneNumber(value) &&
            customPhoneValidation(value, parsedValue?.country)
          : false;
        onChange?.(value as string, isValid);
      }}
      {...restProps}
    />
  );
};

export default ReactPhoneNumberInput;
